import { useState } from 'react';
import { CUSTOMER_COUNTRY_CODES, getCustomerCountryName } from '../../../services/countriesService';

interface CustomerCountryListProps {
  selectedCountries: string[];
  onCountriesChange: (countries: string[]) => void;
}

function CustomerCountryList({ selectedCountries, onCountriesChange }: CustomerCountryListProps): JSX.Element {
  const [searchQuery, setSearchQuery] = useState('');

  const countryList = Array.from(CUSTOMER_COUNTRY_CODES).sort((a, b) => {
    const nameA = getCustomerCountryName(a);
    const nameB = getCustomerCountryName(b);
    return nameA.localeCompare(nameB);
  });

  const query = searchQuery.toLowerCase();
  const filteredList = query
    ? countryList.filter((code) => {
        const name = getCustomerCountryName(code).toLowerCase();
        return name.includes(query) || code.toLowerCase().includes(query);
      })
    : countryList;

  const handleCountryToggle = (countryCode: string) => {
    if (selectedCountries.includes(countryCode)) {
      onCountriesChange(selectedCountries.filter(c => c !== countryCode));
    } else {
      onCountriesChange([...selectedCountries, countryCode]);
    }
  };

  return (
    <>
      <span className="App-alert-text">Select Customer Countries:</span>
      <div className="App-customer-country-list">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          placeholder="Search by country or code..."
          className="App-country-search"
        />
        <div className="App-country-checkboxes">
          {filteredList.map((countryCode) => {
            const countryName = getCustomerCountryName(countryCode);
            const isSelected = selectedCountries.includes(countryCode);
            
            return (
              <label key={countryCode} className="App-country-checkbox-item">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleCountryToggle(countryCode)}
                  className="App-country-checkbox"
                />
                <span className="App-country-name">{countryName}</span>
              </label>
            );
          })}
        </div>
        <div className="App-country-list-footer">
          {selectedCountries.length > 0 && (
            <>
              <div className="App-selected-countries-count">
                {selectedCountries.length} countr{selectedCountries.length === 1 ? 'y' : 'ies'} selected
              </div>
              <button
                className="App-unselect-button"
                onClick={() => onCountriesChange([])}
                type="button"
              >
                Reset
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default CustomerCountryList;

